import mapMarkers, { MarkerDefintion } from './index';
import { assetURL } from '../../url';
import mapboxgl from 'mapbox-gl';

function addMarkersToMap( ctx: mapboxgl.Map ): Promise<void> {
    return new Promise( function( resolve, reject ) {
        let loadCount = 0;

        mapMarkers.forEach( function( marker: MarkerDefintion ) {
            if ( marker.src ) {
                const svgBlob = new Blob( [ marker.src ], { type: 'image/svg+xml' } );
                const url = URL.createObjectURL( svgBlob );
                const img = new Image();

                img.src = url;

                img.onload = () => {
                    // 3. Draw the SVG onto a canvas
                    const canvas = document.createElement( 'canvas' );
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const context = canvas.getContext( '2d' ) as CanvasRenderingContext2D;
                    context.drawImage( img, 0, 0 );

                    // 4. Convert canvas to ImageData
                    const imageData = context.getImageData( 0, 0, canvas.width, canvas.height );

                    // 5. Add image to Mapbox
                    ctx.addImage( marker.name, {
                        width: canvas.width,
                        height: canvas.height,
                        data: imageData.data,
                    } );

                    URL.revokeObjectURL( url );
                };

                loadCount++;

                if ( loadCount === mapMarkers.length ) {
                    resolve();
                }
            } else {
                const icon = new Image( marker.width, marker.height );

                icon.crossOrigin = 'anonymous';

                icon.onerror = function() {
                    reject( new Error( `failed loading marker: ${marker.name}` ) );
                };

                icon.onload = function() {
                    if ( ctx.hasImage( marker.name ) ) {
                        ctx.removeImage( marker.name );
                    }

                    ctx.addImage( marker.name, icon );

                    loadCount++;

                    if ( loadCount === mapMarkers.length ) {
                        resolve();
                    }
                };

                icon.src = assetURL( `/images/${marker.name}.svg` ).toString();
            }
        } );
    } );
}

function addMarkerToMap( ctx: mapboxgl.Map, markerName: string ): Promise<void> {
    return new Promise( function( resolve, reject ) {
        const matchingMarker = mapMarkers.find( ( m: MarkerDefintion ) => m.name === markerName );

        if ( !matchingMarker ) {
            reject( new Error( `no matching markers for id: ${markerName}` ) );
            return;
        }

        const marker = matchingMarker;

        if ( marker.src ) {
            const svgBlob = new Blob( [ marker.src ], { type: 'image/svg+xml' } );
            const url = URL.createObjectURL( svgBlob );
            const img = new Image();

            img.src = url;

            img.onload = () => {
                // 3. Draw the SVG onto a canvas
                const canvas = document.createElement( 'canvas' );
                canvas.width = img.width;
                canvas.height = img.height;
                const context = canvas.getContext( '2d' ) as CanvasRenderingContext2D;
                context.drawImage( img, 0, 0 );

                // 4. Convert canvas to ImageData
                const imageData = context.getImageData( 0, 0, canvas.width, canvas.height );

                // 5. Add image to Mapbox
                ctx.addImage( marker.name, {
                    width: canvas.width,
                    height: canvas.height,
                    data: imageData.data,
                } );

                URL.revokeObjectURL( url );

                resolve();
            };
        } else {
            const icon = new Image( marker.width, marker.height );

            icon.crossOrigin = 'anonymous';

            icon.onerror = function() {
                reject( new Error( `failed loading marker: ${marker.name}` ) );
            };

            icon.onload = function() {
                try {
                    if ( ctx.hasImage( markerName ) ) {
                        reject( new Error( `cannot add duplicate marker with id: ${markerName}` ) );
                    }

                    ctx.addImage( marker.name, icon );
                } catch ( err ) {
                    reject( err );
                }
                resolve();
            };

            icon.src = assetURL( `/images/${marker.name}.svg` ).toString();
        }
    } );
}

export {
    addMarkersToMap,
    addMarkerToMap,
};
